<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
</style>
<template>
  <CCard>
    <CCardHeader class="bg-primary text-white d-flex align-items-center font-weight-bold">
      Pengajuan Rekomendasi
    </CCardHeader>
    <ul class="nav nav-tabs bg-active border-0" id="myTab" role="tablist">
      <li class="nav-item">
        <router-link
          to="/keanggotaan/pengajuan-rekomendasi/unverified"
          class="nav-link p-3 px-5 font-weight-bold text-white border-0"
          style="background-color: #486ba7;"
          id="home-tab"
          data-toggle="tab"
          role="tab"
          aria-controls="data-anggota"
          aria-selected="true"
        >
          Belum Terverifikasi <span class="badge badge-danger">{{ totalElementUnverif }}</span> </router-link>
      </li>
      <li class="nav-item">
        <router-link
          to="/keanggotaan/pengajuan-rekomendasi"
          class="nav-link p-3 px-5 font-weight-bold text-white border-0"
          style="background-color: #214073;"
          id="home-tab"
          data-toggle="tab"
          role="tab"
          aria-controls="data-anggota"
          aria-selected="true">

          Terverifikasi
          <span class="badge badge-success">{{ totalElementVerif }}</span>
        </router-link>
      </li>      
    </ul>
    <!-- Data BPK -->
    <CCardBody>
      <CRow class="mb-3">
        <div class="col-sm-12 col-xl-12">          
          <div class="form-group">
              <label for="" class="font-weight-bold">Pilih Jenis Surat Rekomendasi</label>
              <multiselect
                class="mulit-select"
                label="namaRekomendasi"
                placeholder="Pilih jenis surat rekomendasi"
                :show-labels="false"
                required
                @input="pilihRekomendasi"
                v-model="SuratRekomendasi"
                :options="dataRekomendasi"
              ></multiselect>
            </div>
            <div class="text-right">
              <button class="btn btn-md btn-info mr-2" @click="resetFilter">Reset Filter</button>
              <button class="btn btn-md btn-success" @click="terapkanFilter">Terapkan</button>
            </div>
      </div>
      </CRow>
      <CRow>
        <CSelect
            label="Data Perhalaman"
            class="float-left ml-3"
            @change="changePageSize"
            :options="[10, 25, 100, 'Semua Data']"
          />        
        <CInput
          label="Pencarian"
          class="form-group col-sm-12 col-xl-3 ml-auto"
          placeholder="Cari Data .."
          @keyup="cariData"
          v-model="search"
        />
      </CRow>
      <CRow>
        <CCol lg="12" class="table-responsive">
          <CDataTable
            style="widht:100% !important"
            :items="items"
            :fields="fields"
            hover
            sorter
            class="text-left"
          >
            <template #no="{index}">
              <td class="py-2">{{indexed == 0 ? index +1: index+indexed + 1}}</td>

            </template>
            <template #no_anggota="{item}">
              <td
                class="py-2 text-left font-weight-bold"
              >{{item.no_anggota ? item.no_anggota : "-"}}</td>
            </template>
            <template #nama_lengkap="{item}">
              <td class="py-2 text-left">{{item.nama_lengkap ? item.nama_lengkap : "-"}}</td>
            </template>
            <template #nama_kategori="{item}">
              <td class="py-2 text-left">{{item.nama_kategori ? item.nama_kategori : "-"}}</td>
            </template>
            <template #email="{item}">
              <td class="py-2 text-left">{{item.email ? item.email : "-"}}</td>
            </template>
            <template #nama_rekomendasi="{item}">
              <td class="py-2 text-left">{{item.nama_rekomendasi ? item.nama_rekomendasi : "-"}}</td>
            </template>
            <template #tanggal_pengajuan="{item}">
              <td class="py-2 text-left">{{item.tanggal_pengajuan ? item.tanggal_pengajuan : "-"}}</td>
            </template>
           <template #status_pengajuan="{item}">
              <td class="py-2">
                <span
                  class="btn btn-sm btn-success"
                  v-if="item.status_pengajuan == 1"
                >Terverifikasi</span>
                <span class="btn btn-sm btn-danger" v-else>Belum Terverifikasi</span>
              </td>
            </template>
            <template #aksi="{item, index}">
              <td class="py-2 d-flex align-items-center">
                <template v-if="role_status && role_status.status_update">
                 <CButton 
                  v-c-tooltip="'Ubah'" 
                  :disabled="item.status_dokumen == 0" 
                  :color="item.status_dokumen == 0 ? 'secondary' : 'info'" 
                  class="btn-sm text-white" 
                  square 
                  @click="updateData(item)">
                  <font-awesome-icon icon="edit" />
                </CButton>&nbsp;&nbsp;
                </template>
                <template v-if="role_status && role_status.status_read">
                <router-link
                  :to="'/keanggotaan/pengajuan-rekomendasi/persyaratan-dokumen/'+item.id_rekomendasi_peserta"
                >
                  <CButton v-c-tooltip="'Lihat Dokumen'"  color="warning" class="btn-sm text-white mx-1" square>
                    <font-awesome-icon icon="file" />
                  </CButton>                  
                </router-link>&nbsp;&nbsp;
                </template>
                <template v-if="role_status && role_status.status_delete">
                <CButton v-c-tooltip="'Hapus'" color="danger" class="btn-sm" square @click="deleteData(item, index)">
                  <font-awesome-icon icon="trash" />
                </CButton>
                </template>
              </td>
            </template>
          </CDataTable>
          <CPagination
            style="float:right"
            :active-page.sync="currentPage"
            :pages="pagination.totalPages"
            responsive
          />
          <!-- <CPagination style="float:right" :active-page.sync="currentPage" :pages="10" responsive /> -->
        </CCol>
      </CRow>
      <!-- Modal Tambah -->
      <CModal
        title="Modal title"
        :show.sync="myModal"
        :no-close-on-backdrop="true"
        :centered="true"
      >
        <CForm v-on:submit.prevent="postData">
          <CRow>
            <div class="modal-body">
              <form>
                <div class="form-row">
                  <div class="form-group col-md-12">
                    <label for="no_agt" class="font-weight-bold">Nomor Anggota</label>
                    <input
                      type="text"
                      class="form-control"
                      id="no_anggota"
                      placeholder="Terisi Otomatis"
                      v-model="formData.no_anggota"
                      readonly
                    />
                   
                  </div>
                  <div class="form-group col-md-12">
                    <label for="nama" class="font-weight-bold">Nama Anggota</label>
                    <input
                      type="text"
                      class="form-control"
                      id="nama"
                      placeholder="Terisi Otomatis"
                      v-model="formData.nama_lengkap"
                      readonly
                    />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-12">
                    <label for="kategori_agt" class="font-weight-bold">Kategori Anggota</label>
                    <input
                      type="text"
                      class="form-control"
                      id="nama"
                      placeholder="Terisi Otomatis"
                      v-model="formData.nama_kategori"
                      readonly
                    />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-12">
                    <label for="email_agt" class="font-weight-bold">Email Anggota</label>
                    <input
                      type="email"
                      class="form-control"
                      id="email_agt"
                      placeholder="Terisi Otomatis"
                      v-model="formData.email"
                      readonly
                    />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-12">
                    <label for="kategori" class="font-weight-bold">Jenis Surat Rekomendasi</label>
                    <multiselect
                      class="mulit-select"
                      label="namaRekomendasi"
                      placeholder="Pilih jenis surat rekomendasi"
                      :show-labels="false"
                      required
                      v-model="namaRekomendasiModal"
                      @input="selectRekomendasiModal"
                      :options="dataRekomendasiModal"
                    ></multiselect>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-12">
                    <label for class="font-weight-bold">Status</label>
                    <div class="d-flex align-items-center">
                      <div class="custom-control custom-radio custom-control-inline">
                        <input
                          type="radio"
                          class="custom-control-input"
                          name="customRadio"
                          id="aktif"
                          value="1"
                          v-model="formData.statusPengajuan"
                        />
                        <label class="custom-control-label" for="aktif">Terverifikasi</label>
                      </div>
                      <div class="custom-control custom-radio custom-control-inline">
                        <input
                          type="radio"
                          class="custom-control-input"
                          name="customRadio"
                          id="tidak_aktif"
                          value="0"
                          v-model="formData.statusPengajuan"
                        />
                        <label class="custom-control-label" for="tidak_aktif">Tidak Terverifikasi</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-row" v-show="formData.statusPengajuan == '1'">
                  <div class="form-group col-12">
                    <label  class="font-weight-bold">
                      Unggah File Rekomendasi
                      <small v-if="actionPost == 'update'">
                        <span @click="lihatFile(fileName)">(Lihat File)</span>
                      </small>
                    </label>
                    <br />
                    <div class="custom-file text-truncate">
                      <input type="file" class="custom-file-input" id="customFileLangHTML" ref="uploadFileMasterDokumen" @change="fileUpload"/>
                      <label class="custom-file-label" for="customFileLangHTML" data-browse="Unggah">
                        {{ fileName }}
                      </label>                        
                    </div>
                    <small class="text-danger">(*File harus bertipe PDF max. 10MB)</small>
                  </div>
                </div>
                <div class="form-row" v-show="formData.statusPengajuan == '0'">
                  <div class="form-group col-12">
                    <label for="alamat" class="font-weight-bold">Alasan</label>
                    <textarea
                      type="text"
                      class="form-control"
                      id="alamat"
                      v-model="formData.alasan"
                    />
                  </div>
                </div>
              </form>
            </div>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">{{title}}</h6>
        </template>
        <template #footer>
          <CButton @click="myModal = false" color="danger">Tutup</CButton>
          <CButton @click="postData" type="submit" color="success">Simpan</CButton>
        </template>
      </CModal>
      <!-- End Modal -->
    </CCardBody>
    <!-- End Data BPK -->
  </CCard>
</template>
<script>
import RekomendasiService from "@/services/keanggotaan/rekomendasi.service";
import DataKeanggotaanService from "@/services/keanggotaan/data-anggota.service";
import KategoriAnggotaService from "@/services/keanggotaan/kategori-anggota.service";
import BaseUrl from "@/services/base-url"

const fields = [
  { key: "no" },
  {
    key: "no_anggota",
    label: "No. Anggota"
  },
  { key: "nama_lengkap", label: "Nama Anggota" },
  { key: "email", label: "Email Anggota" },
  { key: "nama_kategori", label: "Kategori Anggota" },
  { key: "nama_rekomendasi", label: "Jenis Surat Rekomendasi" },
  { key: "tanggal_pengajuan"},
  {
    key: "status_pengajuan",
    label: "Status Pengajuan",
    _style: "text-align: center"
  },
  { key: "aksi", _style: "width:12%; text-align: center" }
];
export default {
  data() {
    return {
      search: "",
      items: [],
      pageSize: 10,
      filter : {
        idRekomendasi : ''
      },
      totalElementVerif : 0,
      totalElementUnverif: 0,
      status_pengajuan: "belum_terverifikasi",
      actionPost: "",
      dataRekomendasi: [],
      dataRekomendasiModal: [],
      namaRekomendasiModal : [],
      dataKategori: [],
      no_anggota: [],
      dataAnggota: [],

      dataUser: [],
      multi_user: [
        {
          id_user: null,
          email: "",
          nama_lengkap: null,
          nama_kategori: "",
          no_anggota: ""
        }
      ],
      SuratRekomendasi: [],
      idRekomendasi: "",
      namaRekomendasi: "",
      formData: {
        file : "",
        no_anggota: "",
        nama_lengkap: "",
        email: "",
        nama_kategori: "",
        nama_rekomendasi: "",
        id_rekomendasi_peserta: "",
        status_pengajuan: "",
        statusPengajuan: "",
        idRekomendasi: "",
        updated_by: "",
        namaKategori: "",
        alasan: "",
      },
      pagination: {
        totalPages: 0
      },
      title: "",
      fields,
      currentPage: 0,
      details: [],
      no: 1,
      status: false,
      myModal: false,
      myModalDetail: false,
      horizontal: { label: "col-3", input: "col-9" },
      collapseDuration: 0,
      content: [],
      baseUrl: '',
      fileName : "",
      indexed : 0,
      role_status : null

    };
  },
  mounted() {
    this.roleData();
    this.baseUrl = BaseUrl();

    this.getData("0", this.pageSize, "default",'default', this.status_pengajuan);
    this.getSuratRekomendasi();
    this.getDataAnggota();
    this.getKategori();
    this.getTotalElementUnverif();
    this.getTotalElementVerif();
  },

  watch: {
    multi_user : function(val) {
      this.formData.idUser = val.id_user
    },
    currentPage: function(val) {
      var page = val - 1;
      this.indexed = page * this.pageSize;
      this.getData(val - 1, this.pageSize, this.search,this.filter.idRekomendasi, this.status_pengajuan);
      
    }
  },

  methods: {
    roleData()
      {
        var user = JSON.parse(localStorage.getItem('user'));
        var data = user.singleData.detail_user.roles.find(el => el.url === '/keanggotaan/pengajuan-rekomendasi/unverified' );  
        this.role_status = data;
      },
    resetFilter() {
      this.SuratRekomendasi = []
    },

    pilihRekomendasi(val) {
      this.filter.idRekomendasi = val.idRekomendasi;
    },

    selectRekomendasiModal(val) {
      this.formData.idRekomendasi = val.idRekomendasi;
    },

    terapkanFilter() {
      this.getData(0, this.pageSize, this.search,this.filter.idRekomendasi, this.status_pengajuan);
    },

    fileUpload(e) {
      var typeDok = e.target.files[0].type;
      var typeDokumen = typeDok.split("/");
      if (typeDokumen[1] != "pdf") {
        this.alertError("Dokumen Harus Bertipe PDF");
        return false;
      } else {
        this.formData.file =
          e.target.files[0];
        this.fileName =
          e.target.files[0].name;
      }
    },

    lihatFile(file) {
      if (file != "" && file != null) {
        let routeData =
          this.baseUrl +
          "/files?filename=" +
          file +
          "&path=keanggotaan@rekomendasi";
        let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=0,height=0,left=-1000,top=-1000`;
        window.open(
         routeData,
          file,
          params
        );
        return false;
      } else {
        this.$swal.fire({
          title: "Informasi",
          text: "File Tidak Ditemukan.",
          icon: "info",
          confirmButtonText: "Tutup",
          showConfirmButton: true
        });
      }
    },

    changePageSize(e) {
      var pageSize = "";

      if (e.target.value == "Semua Data") {
        pageSize = 500;
        this.pageSize = pageSize;
      } else {
        pageSize = e.target.value;
        this.pageSize = pageSize;
      }
      this.getData("0", pageSize, this.search,this.filter.idRekomendasi, this.status_pengajuan);
    },

    cariData() {
      clearTimeout(this.timeout);
      var vm = this
      this.timeout = setTimeout(function () {
          // enter this block of code after 1 second
          // handle stuff, call search API etc.
          var searchVar = vm.search.trimStart();
          var searchFinal = searchVar.trimEnd();

          vm.getData("0", vm.pageSize, searchFinal);
      }, 1000);
    },
    
    alertError() {
      this.$swal.fire({
        title: "Peringatan!",
        text: "Data Gagal Disimpan",
        icon: "errorr",
        showCancelButton: true
      });
    },

    alertError(message) {
      this.$swal.fire({
        title: "Peringatan!",
        text: message,
        icon: "errorr",
        showCancelButton: true
      });
    },

    alertSuccess() {
      var vm = this;
      const Toast = vm.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: toast => {
          toast.addEventListener("mouseenter", vm.$swal.stopTimer);
          toast.addEventListener("mouseleave", vm.$swal.resumeTimer);
        }
      });
      Toast.fire({
        icon: "success",
        title: "Data Berhasil Disimpan"
      });
    },

    deleteData(item, index) {
      
      this.formData = item;
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            let loaderDelete = this.$loading.show({
              container: false ? null : this.$refs.formContainer,
              canCancel: true,
              onCancel: this.onCancel,
            });
            RekomendasiService.deleteRekomendasi(this.formData)
              .then(response => {
                this.alertSuccess();
                this.getData("0", this.pageSize, "default",'default');
                loaderDelete.hide()
              })
              .catch(error => {
                this.alertError();
                loaderDelete.hide()
              });
            Toast.fire({
              icon: "cancel",
              title: "Data Berhasil Dihapus"
            });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },

    getData(currentPage, pageSize, filter, idRekomendasi, status_pengajuan) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });
      RekomendasiService.getRekomendasi(currentPage, pageSize, filter, idRekomendasi, this.status_pengajuan)
        .then(response => {
          this.items = response.data.data.content;

          this.pagination.totalPages = response.data.data.totalPages;
          this.currentPage = response.data.data.pageable.pageNumber + 1;
          loader.hide()
        })
        .catch(error => {
          // comment console console.log(error);
          loader.hide()
        });
    },

    getKategori() {
      KategoriAnggotaService.getAllKategoriAnggota()
        .then(response => {
          this.dataKategori = response.data.data.content; 
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },

    getSuratRekomendasi() {
      var vm = this;
      RekomendasiService.getSuratRekomendasi()
        .then(response => {

          var modalRekomendasi = response.data.data;
          vm.dataRekomendasi =  [{
            namaRekomendasi : 'Semua',
            idRekomendasi : 'default'
          }];

          response.data.data.forEach(element => {
            vm.dataRekomendasi.push(element)
          });

          vm.dataRekomendasiModal = modalRekomendasi;
        })
        .catch(error => {
        });
    },

    getDataAnggota() {
      var vm = this;
      DataKeanggotaanService.getAllDataAnggota()
        .then(response => {
          vm.dataUser = response.data.data;
        })
        .catch(error => {
        });
    },

    getTotalElementVerif() {
      
      RekomendasiService.getRekomendasi(
        "0",
        this.pageSize,
        "default",
        "default",
        "terverifikasi"
      )
        .then((response) => {
          this.totalElementVerif = response.data.data.totalElements;
        })
        .catch((error) => {
          // comment console console.log(error);
        });
    },

    getTotalElementUnverif() {
      
      RekomendasiService.getRekomendasi(
        "0",
        "10",
        "default",
        "default",
        "belum_terverifikasi"
      )
        .then((response) => {
          this.totalElementUnverif = response.data.data.totalElements;
        })
        .catch((error) => {
          // comment console console.log(error);
        });
    },

    createData() {
      this.myModal = true;
      this.formData = {};
      this.namaRekomendasiModal =[]
      this.actionPost = "insert";
      this.title = "Tambah";
    },

    updateData(item) {
      this.myModal = true;  
      this.formData.no_anggota = item.no_anggota
      this.formData.nama_lengkap = item.nama_lengkap
      this.formData.nama_kategori = item.nama_kategori
      this.formData.email = item.email  
      this.formData.nama_rekomendasi = item.nama_rekomendasi
      this.formData.id_rekomendasi_peserta = item.id_rekomendasi_peserta;
      this.formData.statusPengajuan = item.status_pengajuan;
      this.formData.idRekomendasi = item.id_rekomendasi;
      this.idRekomendasi = item.id_rekomendasi
      this.namaRekomendasiModal = {
        namaRekomendasi: item.nama_rekomendasi
      }
      this.fileName = item.file
      this.actionPost = "update";
      this.title = "Edit";
    },

    postData() {
      if (this.actionPost == "insert") {
        return false;
      } else if (this.actionPost == "update") {
        this.putData();
      }
    },

    putData() {
      var formData = this.formData;
      if (typeof formData.file === "string") {
        delete formData.file
      }
      if (formData.contohDokumen === null) {
        delete formData.file
      }
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });
      RekomendasiService.putRekomendasi(formData)
        .then(response => {
          this.myModal = false;
          this.$refs.uploadFileMasterDokumen.value = null;
          loader.hide()
          this.alertSuccess();

          this.getData("0", this.pageSize, 'default',this.filter.idRekomendasi, this.status_pengajuan);
        })
        .catch(error => {
          loader.hide()

          this.alertError();
        });
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
